import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from '../DataService/data.service';
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
const AUTH_API = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class LoginService 
{
  _authServiceComponent: any = {};
  _authServiceObj: any = {};
  constructor(private http: HttpClient, private dataService: DataService) {}
  getToken(): Observable<any> 
  {
    return this.http.get(AUTH_API + '/physician/Refreshtoken', {
      headers : {
        "Authorization": `Bearer ${localStorage.getItem(this.dataService.gettingLocalStorageKeys(LocalStorage.token))}`
    } 
    });
  }
  login(obj: any) 
  {
    return this.http.post(AUTH_API + '/physician/auth', obj);
  }
}
